<template>
    <span class="sort_icon">
        <span v-if="updown === 'up'" class="sort_icon__up">
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.21143 4.6169L1.91421 7.91411L0.5 6.4999L6.21132 0.788574L11.9226 6.4999L10.5084 7.91411L7.21143 4.6171V13.2112H5.21143V4.6169Z" fill="#BDBDBD"/>
            </svg>
        </span>
        <span v-if="updown === 'down'" class="sort_icon__down">
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.86119 9.43347L10.1352 6.1132L11.5593 7.51745L5.88818 13.2687L0.136923 7.59761L1.54118 6.1735L4.86124 9.4473L4.80094 0.853394L6.80089 0.83936L6.86119 9.43347Z" fill="#BDBDBD"/>
            </svg>
        </span>
    </span>
</template>

<script>
export default {
    props: ['updown']
}
</script>

<style scoped>

</style>
